import dayjs from 'dayjs';
import type {UAV_POINT_CLOUD_STATUS, UavPointCloud} from '@/domain/entities/UavPointCloud';
import type {UavPointCloudDto} from './UavPointCloudDto';

export const toDto = (domain: UavPointCloud): UavPointCloudDto => ({
  uuid: domain.uuid,
  forestMassUuid: domain.forestMassUuid,
  status: domain.status,
  flightDate: domain.flightDate.toISOString(),
  lidarTechnologyUuid: domain.lidarTechnologyUuid,
  height: domain.height,
  speed: domain.speed,
  overlapPercentage: domain.overlapPercentage,
  comments: domain.comments,
  createdAt: domain.createdAt.toISOString(),
});

export const toDomain = (dto: UavPointCloudDto): UavPointCloud => ({
  ...dto,
  flightDate: dayjs(dto.flightDate),
  createdAt: dayjs(dto.flightDate),
  status: dto.status as UAV_POINT_CLOUD_STATUS,
});
